import {createContext, useEffect, useState} from "react";
import useCallDataApi from "../hooks/data";
import {getSubdomain} from "../utils/Utils";

const SubscriptionContext = createContext();

export default SubscriptionContext;

export const SubscriptionProvider = ({ children }) => {
    const [features, setFeatures] = useState([])
    const [loading, setLoading] = useState(true)
    const {getData} = useCallDataApi('sp-businesses');

    useEffect(() => {
        const subdomain = getSubdomain()
        setLoading(true)
        getData(`get_plan_features/?subdomain=${subdomain}`)
            .then(f => {
                setFeatures(f)
            })
            .finally(() => setLoading(false))
    }, []);


    const hasPlan = (resource, action) => {
        if (loading) return false
        if (Object?.entries(features).length === 0) return false
        const feature = features?.find(f => f?.resource === resource)
        if (feature == null) return false;
        const permission = feature?.[action]
        if (permission == null) return false;
        if (typeof permission === "boolean") return permission;
        return false
    }

    const contextData = {
        hasPlan,
    }

    return <SubscriptionContext.Provider value={contextData}>
        {children}
    </SubscriptionContext.Provider>
}